import dayjs from "dayjs";
import { DocumentReference } from "fhir/r5";
import { ProcedureRequestActions } from "./ProcedureRequestActions";
import { EhrMobileGenericSection } from "../../mobile/EhrMobileGenericSection";

export function ProcedureRequest({
  data,
  title,
  handleOpen,
  procedimentos,
  setBinaryUrl,
  resultsData,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const results = resultsData?.[0]?.entry;

  const documentReference = data?.[0]?.entry?.filter((el: any) => {
    return (
      el?.resource?.resourceType === "DocumentReference" &&
      el?.resource?.category?.[0].coding?.[0].display === "Procedimento"
    );
  });

  const columns = [
    { column: "Descrição", rowName: "description" },
    { column: "Data", rowName: "date" },
    { column: "Profissional solicitante", rowName: "practitioner" },
  ];

  const rowData = procedimentos?.[0]?.entry
    ?.filter(
      (valueFilter: any) =>
        valueFilter?.resource?.category?.[0]?.text === "procedure"
    )
    ?.map((el: any) => {
      const description =
        el?.resource?.code?.concept?.coding?.[0]?.display || "-";
      const date = dayjs(el?.resource?.authoredOn).format("DD/MM/YYYY") || "-";
      const category = el?.resource?.category?.[0]?.text || "-";
      const rawPractitioner = el?.resource?.contained?.[0]?.name?.[0]?.text;
      const practitioner = rawPractitioner ? `Dr(a). ${rawPractitioner}` : "-";
      const status = el?.resource?.status;

      const docReference = documentReference?.find(
        (doc: fhir5.BundleEntry<DocumentReference | any>) => {
          const findRef = doc?.resource?.basedOn?.[0]?.reference?.includes(
            el?.resource?.id
          );
          return findRef;
        }
      );

      const auxResults = results?.find((result: any) => {
        const findRef =
          result?.resource?.basedOn
            ?.find((bas: any) => bas.reference.includes("ServiceRequest"))
            ?.reference?.split("/")?.[1] === el?.resource?.id;
        return findRef;
      });
      const resultUrl =
        auxResults?.resource?.content?.[0]?.attachment?.url || "";

      const binaryUrl =
        docReference?.resource?.content?.[0]?.attachment?.url || "";

      return {
        encounterId: el?.resource?.encounter?.reference?.split("/")?.[1],
        description,
        date,
        category,
        practitioner,
        resultUrl,
        binaryUrl,
        status,
      };
    })
    ?.sort((a: any, b: any) => {
      const dateA = dayjs(a.date, "DD/MM/YYYY");
      const dateB = dayjs(b.date, "DD/MM/YYYY");
      return dateB.diff(dateA);
    });

  return (
    <EhrMobileGenericSection
      title={title}
      columns={columns}
      rows={rowData ?? []}
      actions={(rowData: any) => (
        <ProcedureRequestActions
          verifyVisualizer={verifyVisualizer}
          openVisualizer={openVisualizer}
          row={rowData}
          handleOpen={handleOpen}
          setBinaryUrl={setBinaryUrl}
        />
      )}
    />
  );
}
